module.exports = __webpack_public_path__ + "static/media/Carousels-Adventure-Mobile.7732a246.jpg";